"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyTopicPollOption = createEmptyTopicPollOption;
exports.createEmptyTopicPollQuestion = createEmptyTopicPollQuestion;
exports.createEmptyTopicPollDraft = createEmptyTopicPollDraft;
exports.topicPollQuestionToDraft = topicPollQuestionToDraft;
exports.topicPollToDraft = topicPollToDraft;
exports.isTopicPollDraft = isTopicPollDraft;
exports.validateTopicPollDraft = validateTopicPollDraft;
exports.serializeTopicPollForFt = serializeTopicPollForFt;
exports.resolveTopicPollWireData = resolveTopicPollWireData;
function createEmptyTopicPollOption() {
    return { label: '', votes: 0 };
}
function createEmptyTopicPollQuestion() {
    return {
        text: '',
        multiple: false,
        options: [createEmptyTopicPollOption(), createEmptyTopicPollOption()],
    };
}
function createEmptyTopicPollDraft() {
    return {
        enabled: false,
        hadPoll: false,
        title: '',
        questions: [createEmptyTopicPollQuestion()],
    };
}
function topicPollQuestionToDraft(question) {
    return {
        text: question.text,
        multiple: question.multiple,
        options: question.options.map((option) => ({
            label: option.label,
            votes: option.votes,
        })),
    };
}
function topicPollToDraft(poll) {
    if (!poll)
        return createEmptyTopicPollDraft();
    return {
        enabled: true,
        hadPoll: true,
        title: poll.title,
        questions: poll.questions.length > 0
            ? poll.questions.map(topicPollQuestionToDraft)
            : [createEmptyTopicPollQuestion()],
    };
}
function isTopicPollDraft(value) {
    if (!value || typeof value !== 'object')
        return false;
    const draft = value;
    return typeof draft.enabled === 'boolean'
        && typeof draft.hadPoll === 'boolean'
        && typeof draft.title === 'string'
        && Array.isArray(draft.questions);
}
/** Проверка черновика. `null` — ок; иначе текст ошибки для UI. */
function validateTopicPollDraft(draft) {
    if (!draft.enabled)
        return null;
    const title = draft.title.trim();
    if (!title)
        return 'Укажите заголовок опроса';
    if (draft.questions.length === 0) {
        return 'Добавьте хотя бы один вопрос';
    }
    for (let questionIndex = 0; questionIndex < draft.questions.length; questionIndex++) {
        const question = draft.questions[questionIndex];
        const questionText = question.text.trim();
        if (!questionText) {
            return `Укажите текст вопроса ${questionIndex + 1}`;
        }
        const options = question.options
            .map((option) => option.label.trim())
            .filter((label) => label.length > 0);
        if (options.length === 0) {
            return `Добавьте хотя бы один ответ в вопросе ${questionIndex + 1}`;
        }
    }
    return null;
}
function serializeTopicPollForFt(draft) {
    if (!draft.enabled) {
        return draft.hadPoll ? [] : null;
    }
    const title = draft.title.trim();
    const questions = [];
    for (const question of draft.questions) {
        const options = [];
        const votes = [];
        for (const option of question.options) {
            const label = option.label.trim();
            if (!label)
                continue;
            options.push(label);
            votes.push(Math.max(0, option.votes | 0));
        }
        const text = question.text.trim();
        if (!text || options.length === 0)
            continue;
        questions.push([
            text,
            question.multiple ? 1 : 0,
            options,
            votes,
        ]);
    }
    if (!title || questions.length === 0)
        return null;
    return [title, questions];
}
function resolveTopicPollWireData(poll) {
    if (poll == null)
        return null;
    if (isTopicPollDraft(poll))
        return serializeTopicPollForFt(poll);
    return poll;
}
